<main class="policy-page">
  <section class="policy-hero">
    <div class="policy-container">
      <app-navigate-back class="mb-4"></app-navigate-back>

      <h1 class="policy-title">
        Shipping Policy &amp; Cancellation Policy
      </h1>

      <p class="policy-subtitle">
        Please review our shipping, delivery, and cancellation terms carefully before placing your order.
      </p>
    </div>
  </section>

  <section class="policy-body">
    <div class="policy-container policy-copy policy-stack">

      <section class="policy-section">
        <p class="policy-paragraph">
          Thank you for shopping with Varroc Connect! We are committed to ensuring your order arrives promptly and securely.
        </p>

        <p class="policy-paragraph">
          Please review our shipping policy to understand how we handle shipping, delivery, and related matters.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Shipping Methods and Options</h2>

        <p class="policy-paragraph">
          We offer only standard shipping for all orders.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Shipping Timeframes</h2>

        <p class="policy-paragraph">
          Orders are typically processed within 24 working hours.
        </p>

        <p class="policy-paragraph">
          Post shipment, the order will be delivered within 5 to 7 working days.
        </p>

        <p class="policy-paragraph">
          Please note that delivery time may vary based on destination, holidays, and unforeseen circumstances.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Tracking and Delivery</h2>

        <p class="policy-paragraph">
          Once your order is shipped, you will receive a shipping confirmation email with tracking information.
        </p>

        <p class="policy-paragraph">
          Use the provided tracking number to monitor the status of your delivery.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Returns and Exchanges</h2>

        <p class="policy-paragraph">
          Please refer to our Returns and Exchanges Policy for information on returning or exchanging items purchased.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Lost or Damaged Shipments</h2>

        <p class="policy-paragraph">
          In the rare event that your shipment is lost or damaged in transit, please contact our customer service team immediately.
        </p>

        <p class="policy-paragraph">
          We will work with our shipping and courier team to resolve the issue and ensure a satisfactory outcome.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Shipping Policy Updates</h2>

        <p class="policy-paragraph">
          We reserve the right to update our shipping policy at any time.
        </p>

        <p class="policy-paragraph">
          Any changes will be effective immediately upon posting on our website.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Contact Us</h2>

        <p class="policy-paragraph">
          If you have any questions about our shipping policy, please contact us at
          <strong>{{SupportEmail}}</strong>.
        </p>

        <p class="policy-paragraph">
          Our customer service team is here to assist you.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Cancellation</h2>

        <p class="policy-paragraph">
          If for any reason, you are not satisfied with our Product or Service and you want to cancel your order, please do so within 2 days of receiving your order.
        </p>

        <p class="policy-paragraph">
          If 2 days have gone by since delivery of the order, unfortunately we cannot process your cancellation.
        </p>

        <p class="policy-paragraph">
          To return your product, please courier it to the following address:
        </p>

        <p class="policy-paragraph">
          <strong>Shipping Manager</strong><br />
          Varroc Connect Private Limited,<br />
          Elpro International, Chinchwad Station Rd,<br />
          Chinchwad Gaon, Chinchwad,<br />
          Pimpri-Chinchwad, Maharashtra 411033
        </p>

        <p class="policy-paragraph">
          Please note that you will be responsible for paying your own shipping costs for returning your item. This amount is not refundable.
        </p>

        <p class="policy-paragraph">
          For any assistance, you can email us at <strong>{{SupportEmail}}</strong>.
        </p>
      </section>

    </div>
  </section>
</main>